import { archiveArea, deleteArea, unarchiveArea } from "services/areas-service";
import { Dialog } from 'Components/ui';

export const callDeleteAction = async (itemToDelete, onClose, refetch, setRefetch) => {
  const result = await deleteArea(itemToDelete?._id);
  if (result.status === 204) {
    onClose();
    setRefetch(!refetch);
    Dialog.alert({
      title: 'Sucesso!',
      message: 'Área removida com sucesso',
      icon: 'success',
    });
  } else {
    throw new Error('Ocorreu um erro ao tentar remover a Área!');
  }
};

export const callArchiveAction = async (itemToArchive, onClose, refetch, setRefetch) => {
  const result = await archiveArea(itemToArchive?._id);
  if (result.status === 200) {
    onClose();
    setRefetch(!refetch);
    Dialog.alert({
      title: 'Sucesso!',
      message: 'Área arquivada com sucesso',
      icon: 'success',
    });
  } else {
    throw new Error('Ocorreu um erro ao tentar arquivar a Área!');
  }
};

export const callUnarchiveAction = async (itemToUnarchive, onClose, refetch, setRefetch) => {
  const result = await unarchiveArea(itemToUnarchive?._id);
  if (result.status === 200) {
    onClose();
    setRefetch(!refetch);
    Dialog.alert({
      title: 'Sucesso!',
      message: 'Área desarquivada com sucesso',
      icon: 'success',
    });
  } else {
    throw new Error('Ocorreu um erro ao tentar desarquivar a Área!');
  }
};
